import {
  Alert,
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import AccountTreeOutlined from "@mui/icons-material/AccountTreeOutlined";
import ApartmentOutlined from "@mui/icons-material/ApartmentOutlined";
import ArticleOutlined from "@mui/icons-material/ArticleOutlined";
import AutoAwesomeOutlined from "@mui/icons-material/AutoAwesomeOutlined";
import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";
import CheckCircleRounded from "@mui/icons-material/CheckCircleRounded";
import ChevronRightRounded from "@mui/icons-material/ChevronRightRounded";
import CloudUploadOutlined from "@mui/icons-material/CloudUploadOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";
import FactCheckOutlined from "@mui/icons-material/FactCheckOutlined";
import CalculateOutlined from "@mui/icons-material/CalculateOutlined";
import FolderOutlined from "@mui/icons-material/FolderOutlined";
import HistoryOutlined from "@mui/icons-material/HistoryOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import PublishedWithChangesOutlined from "@mui/icons-material/PublishedWithChangesOutlined";
import RequestQuoteOutlined from "@mui/icons-material/RequestQuoteOutlined";
import RocketLaunchOutlined from "@mui/icons-material/RocketLaunchOutlined";
import SupportAgentOutlined from "@mui/icons-material/SupportAgentOutlined";
import TimelineOutlined from "@mui/icons-material/TimelineOutlined";
import AccessTimeRounded from "@mui/icons-material/AccessTimeRounded";
import ViewInArOutlined from "@mui/icons-material/ViewInArOutlined";
import WarningAmberRounded from "@mui/icons-material/WarningAmberRounded";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import AddRounded from "@mui/icons-material/AddRounded";
import CalendarMonthOutlined from "@mui/icons-material/CalendarMonthOutlined";
import LocationOnOutlined from "@mui/icons-material/LocationOnOutlined";
import SpaceDashboardOutlined from "@mui/icons-material/SpaceDashboardOutlined";
import SmartToyOutlined from "@mui/icons-material/SmartToyOutlined";
import UploadFileOutlined from "@mui/icons-material/UploadFileOutlined";
import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
import SaveOutlined from "@mui/icons-material/SaveOutlined";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";

const empreendimentos = [
  {
    id: "residencial-alameda-jardins",
    nome: "Residencial Alameda Jardins",
    tipo: "Residencial",
    local: "Sao Paulo/SP",
    status: "Em andamento",
    ultimaAtualizacao: "15/05/2025 as 14:30",
    nucleo: "Hierarquia publicada",
    versao: "Versao 1.0 - 14/05/2025",
    processos: "Registro de Incorporacao; Orcamento & Viabilidade",
  },
  {
    id: "villa-atlantica",
    nome: "Villa Atlantica",
    tipo: "Residencial",
    local: "Balneario Camboriu/SC",
    status: "Em revisao",
    ultimaAtualizacao: "13/05/2025 as 09:45",
    nucleo: "Em revisao",
    versao: "Versao 0.3 - 12/05/2025",
    processos: "Orcamento & Viabilidade",
  },
  {
    id: "torre-empresarial-jardins",
    nome: "Torre Empresarial Jardins",
    tipo: "Comercial",
    local: "Sao Paulo/SP",
    status: "Em andamento",
    ultimaAtualizacao: "10/05/2025 as 16:20",
    nucleo: "Hierarquia publicada",
    versao: "Versao 1.0 - 10/05/2025",
    processos: "Registro de Incorporacao",
  },
  {
    id: "parque-das-flores",
    nome: "Parque das Flores",
    tipo: "Residencial",
    local: "Curitiba/PR",
    status: "Concluido",
    ultimaAtualizacao: "02/05/2025 as 11:10",
    nucleo: "Hierarquia publicada",
    versao: "Versao 1.0 - 02/05/2025",
    processos: "Registro de Incorporacao; Memorial & Manual",
  },
];

const statusPalette = {
  Ativo: "success",
  Beta: "info",
  "Em breve": "default",
  "Em andamento": "primary",
  "Em planejamento": "info",
  "Em estruturacao": "warning",
  "Em revisao": "warning",
  Concluido: "success",
  "Hierarquia publicada": "success",
  "Em execucao": "primary",
  Aguardando: "warning",
  "Acao necessaria": "error",
  "Aguardando hierarquia publicada": "warning",
  "Aguardando revisao final": "warning",
  "Modulo nao contratado": "default",
  Alto: "error",
  Medio: "warning",
  Baixo: "success",
};

const moduleCards = [
  {
    title: "Nucleo de Areas",
    description: "Estrutura espacial e quantitativa do empreendimento.",
    status: "Ativo",
    icon: AccountTreeOutlined,
  },
  {
    title: "Registro de Incorporacao",
    description: "Documentacao e dados para o registro da incorporacao.",
    status: "Ativo",
    icon: FactCheckOutlined,
  },
  {
    title: "Orcamento & Viabilidade",
    description: "Estimativas de custo, viabilidade e cenarios de projeto.",
    status: "Beta",
    icon: RequestQuoteOutlined,
  },
  {
    title: "Memorial & Manual",
    description: "Geracao de memoriais tecnicos e manual do proprietario.",
    status: "Em breve",
    icon: ArticleOutlined,
  },
  {
    title: "NBR 12721",
    description: "Calculo de areas privativas e equivalentes conforme norma.",
    status: "Em breve",
    icon: DescriptionOutlined,
  },
];

const areaImpacts = [
  ["Registro de Incorporacao", "Revisao do memorial descritivo.", "Medio"],
  ["Orcamento & Viabilidade", "Recalcular quantitativos e custo/m2.", "Alto"],
  ["NBR 12721", "A area privativa sera atualizada.", "Baixo"],
  ["Memorial & Manual", "Atualizar especificacao do ambiente.", "Medio"],
  ["Tabela de Vendas", "Impacto no preco/m2 e tabela.", "Medio"],
];

const areaChanges = [
  ["A area aumentou 0,70 m2 (+4,24%). Impacto direto em orcamento, NBR 12721 e tabela de vendas.", "Alto"],
  ["A area total da unidade sera recalculada automaticamente apos a publicacao desta versao.", "Medio"],
  ["Revisar memorial descritivo e plantas do ambiente para manter consistencia documental.", "Medio"],
  ["Nao foram detectadas alteracoes em ambientes dependentes deste item.", "Baixo"],
];

const pageSx = {
  maxWidth: 1240,
  mx: "auto",
  width: "100%",
};

const StatusChip = ({ label, size = "small" }) => (
  <Chip label={label} size={size} color={statusPalette[label] || "default"} variant="outlined" sx={{ fontWeight: 700 }} />
);

const SectionTitle = ({ title, subtitle }) => (
  <Stack spacing={0.4} sx={{ mb: 2 }}>
    <Typography variant="h6" fontWeight={800}>
      {title}
    </Typography>
    {subtitle && <Typography color="text.secondary">{subtitle}</Typography>}
  </Stack>
);

const portalPrimary = "#667eea";
const portalSecondary = "#764ba2";
const portalPrimaryGradient = "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
const portalPrimaryShadow = "0 12px 26px rgba(102, 126, 234, 0.26)";
const portalPrimaryShadowHover = "0 16px 30px rgba(102, 126, 234, 0.3)";

const overviewAccent = portalPrimary;

const AreaStackIllustration = () => {
  return (
    <Box
      sx={{
        width: 120,
        height: 120,
        borderRadius: "24px",
        background: "linear-gradient(135deg, #eef2ff, #f5f0ff)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Box component="svg" aria-hidden viewBox="0 0 120 120" sx={{ width: 78, height: 78, overflow: "visible" }}>
        <ellipse cx="60" cy="91" rx="42" ry="9" fill="#e0e7ff" opacity="0.72" />
        {[
          ["22 63 60 43 98 63 60 84", "#f8fbff", "#818cf8"],
          ["22 54 60 34 98 54 60 75", "#dde7ff", "#818cf8"],
          ["22 45 60 25 98 45 60 66", "#93a9ff", portalPrimary],
          ["22 36 60 16 98 36 60 57", portalPrimary, portalSecondary],
          ["22 27 60 7 98 27 60 48", "#eef2ff", "#818cf8"],
        ].map(([points, fill, stroke], index) => (
          <polygon
            key={points}
            points={points}
            fill={fill}
            stroke={stroke}
            strokeWidth="1.5"
            filter={index === 3 ? "drop-shadow(0 6px 8px rgba(102,126,234,0.22))" : "drop-shadow(0 4px 7px rgba(15,23,42,0.08))"}
          />
        ))}
      </Box>
    </Box>
  );
};

const OverviewCheck = () => (
  <Box
    component="span"
    sx={{
      width: 18,
      height: 18,
      borderRadius: "50%",
      bgcolor: overviewAccent,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      mt: "1px",
    }}
  >
    <Box
      component="span"
      sx={{
        width: 8,
        height: 4,
        borderLeft: "2px solid #fff",
        borderBottom: "2px solid #fff",
        transform: "rotate(-45deg)",
        mt: "-2px",
      }}
    />
  </Box>
);

const OverviewStatusChip = ({ label, tone }) => {
  const tones = {
    success: { bg: "#e9f7ed", color: "#25864a", icon: "#2f9d58" },
    warning: { bg: "#fff3e7", color: "#c46516", icon: "#e17a21" },
    info: { bg: "#eef3ff", color: "#456cf6", icon: "#456cf6" },
  };
  const palette = tones[tone] || tones.info;

  return (
    <Chip
      icon={
        tone === "success" ? (
          <CheckCircleRounded sx={{ color: `${palette.icon} !important`, fontSize: "16px !important" }} />
        ) : tone === "warning" ? (
          <Box
            component="span"
            sx={{
              width: 12,
              height: 12,
              border: `1.8px solid ${palette.icon}`,
              borderRadius: "3px",
              display: "inline-block",
              position: "relative",
              ml: "2px",
              "&::after": {
                content: '""',
                position: "absolute",
                left: "4px",
                top: "2px",
                width: 3,
                height: 5,
                borderRight: `1.8px solid ${palette.icon}`,
                borderBottom: `1.8px solid ${palette.icon}`,
                transform: "rotate(-35deg)",
              },
            }}
          />
        ) : (
          <AccessTimeRounded sx={{ color: `${palette.icon} !important`, fontSize: "15px !important" }} />
        )
      }
      label={label}
      size="small"
      sx={{
        alignSelf: "flex-start",
        bgcolor: palette.bg,
        color: palette.color,
        border: "none",
        fontWeight: 800,
        height: 25,
        borderRadius: "999px",
        fontFamily: "Futura, Arial, sans-serif",
        fontSize: "12px",
        "& .MuiChip-label": { px: 0.6 },
        "& .MuiChip-icon": { ml: "7px", mr: "2px" },
      }}
    />
  );
};

const OverviewStepCard = ({ number, title, text, icon: Icon, tone }) => {
  const tones = {
    blue: { bg: "#eef2ff", color: "#667eea" },
    green: { bg: "#ecfdf3", color: "#16a34a" },
    purple: { bg: "#f3e8ff", color: "#7c3aed" },
    orange: { bg: "#fff3e8", color: "#ea580c" },
  };
  const palette = tones[tone];

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "14px",
        border: "1px solid #e2e8f0",
        p: "20px",
        minHeight: 170,
        height: "100%",
        position: "relative",
        bgcolor: "#fff",
        boxShadow: "0 4px 12px rgba(15, 23, 42, 0.025)",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
          borderColor: "rgba(102, 126, 234, 0.38)",
        },
      }}
    >
      <Stack>
        <Stack direction="row" alignItems="center" spacing="14px" sx={{ mb: "18px" }}>
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: palette.bg,
              color: palette.color,
              fontWeight: 700,
              fontSize: "18px",
              lineHeight: 1,
            }}
          >
            {number}
          </Box>
          <Icon sx={{ fontSize: 28, color: palette.color }} />
        </Stack>
        <Box>
          <Typography
            sx={{
              mb: "8px",
              color: "#1e293b",
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "15px",
              lineHeight: 1.3,
              fontWeight: 700,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: "#64748b",
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "14px",
              lineHeight: 1.55,
              fontWeight: 400,
            }}
          >
            {text}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};

const OverviewModuleCard = ({ title, description, status, icon: Icon, tone }) => {
  const tones = {
    blue: { bg: "#eef2ff", color: "#667eea" },
    green: { bg: "#ecfdf3", color: "#16a34a" },
    orange: { bg: "#fff3e8", color: "#ea580c" },
    purple: { bg: "#f3e8ff", color: "#7c3aed" },
  };
  const palette = tones[tone] || tones.blue;
  const statusTone = status === "Ativo" ? "success" : status === "Beta" ? "warning" : "info";

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "14px",
        border: "1px solid #e2e8f0",
        p: "18px",
        height: "100%",
        minHeight: 184,
        bgcolor: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: "0 4px 12px rgba(15, 23, 42, 0.025)",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
          borderColor: "rgba(102, 126, 234, 0.38)",
        },
      }}
    >
      <Box>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: "14px",
            bgcolor: palette.bg,
          }}
        >
          <Icon sx={{ color: palette.color, fontSize: 26, strokeWidth: 1.8 }} />
        </Box>
        <Box>
          <Typography
            sx={{
              mb: "6px",
              color: "#1e293b",
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "15px",
              lineHeight: 1.3,
              fontWeight: 700,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: "#53627f",
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "13px",
              lineHeight: 1.45,
              fontWeight: 400,
              mb: "16px",
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
      <Box>
        <OverviewStatusChip label={status} tone={statusTone} />
      </Box>
    </Paper>
  );
};

const DashboardBadge = ({ label, bg, color }) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "999px",
      px: "12px",
      py: "6px",
      bgcolor: bg,
      color,
      fontFamily: "Futura, Arial, sans-serif",
      fontSize: "12px",
      fontWeight: 700,
      lineHeight: 1,
      whiteSpace: "nowrap",
    }}
  >
    {label}
  </Box>
);

const DashboardSectionCard = ({ title, linkLabel = "Ver todos", children }) => (
  <Paper
    elevation={0}
    sx={{
      background: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: "16px",
      p: "24px",
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)",
    }}
  >
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: "22px" }}>
      <Typography
        sx={{
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "20px",
          fontWeight: 700,
          color: "#1e293b",
          lineHeight: 1.25,
        }}
      >
        {title}
      </Typography>
      <Button
        endIcon={<ChevronRightRounded sx={{ fontSize: 18 }} />}
        sx={{
          p: 0,
          minWidth: 0,
          color: "#667eea",
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "14px",
          fontWeight: 600,
          "&:hover": { bgcolor: "transparent", color: "#3155c8" },
        }}
      >
        {linkLabel}
      </Button>
    </Stack>
    {children}
  </Paper>
);

const DashboardKpiCard = ({ label, value, icon: Icon, iconColor, iconBackground, valueColor }) => (
  <Paper
    elevation={0}
    sx={{
      background: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: "16px",
      p: "22px 24px",
      display: "flex",
      alignItems: "center",
      gap: "18px",
      minHeight: 120,
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)",
      transition: "all 0.2s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.06)",
        borderColor: "rgba(102, 126, 234, 0.38)",
      },
    }}
  >
    <Box
      sx={{
        width: 64,
        height: 64,
        borderRadius: "999px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        bgcolor: iconBackground,
      }}
    >
      <Icon sx={{ color: iconColor, fontSize: 30, strokeWidth: 1.8 }} />
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography
        sx={{
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "15px",
          fontWeight: 700,
          lineHeight: 1.35,
          color: "#334155",
          mb: "8px",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "32px",
          fontWeight: 800,
          lineHeight: 1,
          color: valueColor,
        }}
      >
        {value}
      </Typography>
    </Box>
  </Paper>
);

const EmpreendimentoRecentCard = ({ name, meta, status, badgeBg, badgeColor, iconColor, iconBackground }) => (
  <Box
    sx={{
      background: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: "14px",
      p: "14px",
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "74px minmax(0, 1fr) auto 24px" },
      gap: { xs: "12px", sm: "16px" },
      alignItems: "center",
      minHeight: 96,
      mb: "14px",
      transition: "all 0.2s ease",
      "&:hover": {
        transform: "translateY(-1px)",
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.05)",
        borderColor: "rgba(102, 126, 234, 0.38)",
      },
    }}
  >
    <Box
      sx={{
        width: 74,
        height: 74,
        borderRadius: "12px",
        overflow: "hidden",
        background: iconBackground,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ApartmentOutlined sx={{ color: iconColor, fontSize: 32 }} />
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography
        sx={{
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "16px",
          fontWeight: 700,
          color: "#1e293b",
          mb: "6px",
          lineHeight: 1.25,
        }}
      >
        {name}
      </Typography>
      <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", color: "#64748b" }}>
        {meta}
      </Typography>
    </Box>
    <Box sx={{ justifySelf: { xs: "start", sm: "end" } }}>
      <DashboardBadge label={status} bg={badgeBg} color={badgeColor} />
    </Box>
    <ChevronRightRounded sx={{ color: "#64748b", fontSize: 18, display: { xs: "none", sm: "block" } }} />
  </Box>
);

const ProcessoAtencaoCard = ({ title, description, status, icon: Icon, iconColor, iconBackground, badgeBg, badgeColor, progress }) => (
  <Box
    sx={{
      background: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: "14px",
      p: "18px",
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "64px minmax(0, 1fr) auto" },
      gap: { xs: "14px", sm: "18px" },
      alignItems: "center",
      minHeight: 110,
      mb: "16px",
      transition: "all 0.2s ease",
      "&:hover": {
        transform: "translateY(-1px)",
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.05)",
        borderColor: "rgba(102, 126, 234, 0.38)",
      },
    }}
  >
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: iconBackground,
      }}
    >
      <Icon sx={{ color: iconColor, fontSize: 28, strokeWidth: 1.8 }} />
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography
        sx={{
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "16px",
          fontWeight: 700,
          color: "#1e293b",
          mb: "6px",
          lineHeight: 1.25,
        }}
      >
        {title}
      </Typography>
      <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", lineHeight: 1.45, color: "#64748b" }}>
        {description}
      </Typography>
      {progress != null && (
        <Box sx={{ width: "100%", height: 6, borderRadius: "999px", bgcolor: "#e2e8f0", mt: "10px", overflow: "hidden" }}>
          <Box sx={{ width: `${progress}%`, height: "100%", borderRadius: "999px", bgcolor: "#667eea" }} />
        </Box>
      )}
    </Box>
    <Box sx={{ justifySelf: { xs: "start", sm: "end" } }}>
      <DashboardBadge label={status} bg={badgeBg} color={badgeColor} />
    </Box>
  </Box>
);

const EmpreendimentoFilterPill = ({ label, count, active, badgeBg, badgeColor }) => (
  <Box
    sx={{
      height: 48,
      minWidth: 150,
      px: "18px",
      borderRadius: "10px",
      border: active ? "1px solid rgba(102, 126, 234, 0.38)" : "1px solid #e2e8f0",
      bgcolor: active ? "#eef2ff" : "#ffffff",
      color: active ? "#667eea" : "#64748b",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      fontFamily: "Futura, Arial, sans-serif",
      fontSize: "14px",
      fontWeight: 700,
      cursor: "default",
      flexShrink: 0,
    }}
  >
    {label}
    <Box
      component="span"
      sx={{
        minWidth: 24,
        height: 24,
        borderRadius: "999px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: badgeBg,
        color: badgeColor,
        fontSize: "12px",
        fontWeight: 800,
      }}
    >
      {count}
    </Box>
  </Box>
);

const empreendimentoStatusStyle = {
  "Em andamento": { bg: "#dcfce7", color: "#15803d" },
  "Em revisao": { bg: "#ffedd5", color: "#c2410c" },
  Concluido: { bg: "#f3e8ff", color: "#7c3aed" },
};

const EmpreendimentoListRow = ({ item, isLast }) => {
  const status = empreendimentoStatusStyle[item.status] || { bg: "#eef2ff", color: "#667eea" };
  const isReview = item.nucleo === "Em revisao";
  const nucleoColor = isReview ? "#c2410c" : "#15803d";
  const nucleoIconColor = isReview ? "#ea580c" : "#16a34a";
  const isCommercial = item.tipo === "Comercial";
  const detailPath = "/aipim-incorp/empreendimentos/residencial-alameda-jardins";

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "82px 1fr",
          lg: "96px minmax(240px, 1.6fr) 150px 200px 220px 190px",
        },
        gridTemplateAreas: {
          xs: `"thumb" "info" "status" "update" "nucleo" "action"`,
          md: `"thumb info" "thumb status" "thumb update" "thumb nucleo" "thumb action"`,
          lg: `"thumb info status update nucleo action"`,
        },
        gap: { xs: "14px", lg: "18px" },
        alignItems: "center",
        p: { xs: "18px", lg: "16px 18px" },
        bgcolor: "#ffffff",
        borderBottom: isLast ? "none" : "1px solid #e2e8f0",
        minHeight: { xs: 124, lg: 108 },
        transition: "all 0.2s ease",
        "&:hover": { bgcolor: "#f8fbff" },
      }}
    >
      <Box
        component={RouterLink}
        to={detailPath}
        aria-label={`Acessar empreendimento ${item.nome}`}
        sx={{
          gridArea: "thumb",
          width: { xs: "100%", md: 82 },
          height: { xs: 140, md: 82 },
          borderRadius: "12px",
          overflow: "hidden",
          background: isCommercial ? "linear-gradient(135deg, #e0f2fe, #ede9fe)" : "linear-gradient(135deg, #dbeafe, #e0e7ff)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          textDecoration: "none",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: "0 8px 18px rgba(15, 23, 42, 0.08)",
          },
        }}
      >
        <ApartmentOutlined sx={{ color: isCommercial ? "#7c3aed" : "#667eea", fontSize: 34 }} />
      </Box>

      <Box sx={{ gridArea: "info", minWidth: 0 }}>
        <Typography
          component={RouterLink}
          to={detailPath}
          sx={{
            display: "inline-block",
            fontFamily: "Futura, Arial, sans-serif",
            fontSize: "18px",
            fontWeight: 700,
            color: "#1e293b",
            lineHeight: 1.3,
            mb: "8px",
            textDecoration: "none",
            transition: "color 0.2s ease",
            "&:hover": { color: "#667eea" },
          }}
        >
          {item.nome}
        </Typography>
        <Stack direction="row" spacing="10px" alignItems="center" useFlexGap flexWrap="wrap">
          <Stack direction="row" spacing="6px" alignItems="center">
            <ApartmentOutlined sx={{ color: "#64748b", fontSize: 16 }} />
            <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", color: "#64748b" }}>{item.tipo}</Typography>
          </Stack>
          <Typography sx={{ color: "#94a3b8" }}>•</Typography>
          <Stack direction="row" spacing="6px" alignItems="center">
            <LocationOnOutlined sx={{ color: "#64748b", fontSize: 16 }} />
            <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", color: "#64748b" }}>{item.local}</Typography>
          </Stack>
        </Stack>
      </Box>

      <Box sx={{ gridArea: "status" }}>
        <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "12px", fontWeight: 700, color: "#64748b", mb: "8px" }}>
          Status
        </Typography>
        <DashboardBadge label={item.status} bg={status.bg} color={status.color} />
      </Box>

      <Box sx={{ gridArea: "update" }}>
        <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "12px", fontWeight: 700, color: "#64748b", mb: "8px" }}>
          Ultima atualizacao
        </Typography>
        <Stack direction="row" spacing="8px" alignItems="center">
          <CalendarMonthOutlined sx={{ color: "#64748b", fontSize: 17 }} />
          <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", fontWeight: 500, color: "#64748b" }}>
            {item.ultimaAtualizacao}
          </Typography>
        </Stack>
      </Box>

      <Box sx={{ gridArea: "nucleo" }}>
        <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "12px", fontWeight: 700, color: "#64748b", mb: "8px" }}>
          Nucleo de Areas
        </Typography>
        <Stack direction="row" spacing="8px" alignItems="center" sx={{ mb: "4px" }}>
          {isReview ? (
            <AccessTimeRounded sx={{ color: nucleoIconColor, fontSize: 16 }} />
          ) : (
            <CheckCircleRounded sx={{ color: nucleoIconColor, fontSize: 16 }} />
          )}
          <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", fontWeight: 700, color: nucleoColor }}>
            {item.nucleo}
          </Typography>
        </Stack>
        <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "13px", color: "#64748b" }}>{item.versao}</Typography>
      </Box>

      <Box sx={{ gridArea: "action", justifySelf: { xs: "stretch", lg: "end" } }}>
        <Button
          component={RouterLink}
          to={detailPath}
          endIcon={<ChevronRightRounded sx={{ fontSize: 18 }} />}
          sx={{
            height: 40,
            px: "14px",
            borderRadius: "10px",
            border: "1px solid #e2e8f0",
            bgcolor: "#ffffff",
            color: "#667eea",
            fontFamily: "Futura, Arial, sans-serif",
            fontSize: "13px",
            fontWeight: 700,
            whiteSpace: "nowrap",
            width: { xs: "100%", lg: "auto" },
            "&:hover": { bgcolor: "#eef2ff", borderColor: "rgba(102, 126, 234, 0.38)" },
          }}
        >
          Acessar empreendimento
        </Button>
      </Box>
    </Box>
  );
};

const FormLabel = ({ children, required }) => (
  <Box component="label" sx={{ display: "block", fontSize: "13px", fontWeight: 700, color: "#334155", mb: "8px" }}>
    {children}
    {required && <Box component="span" sx={{ color: "#667eea", ml: "3px" }}>*</Box>}
  </Box>
);

const fieldSx = {
  width: "100%",
  height: 44,
  borderRadius: "10px",
  border: "1px solid #dbe3f0",
  background: "#ffffff",
  px: "14px",
  fontFamily: "Futura, Arial, sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  color: "#1e293b",
  outline: "none",
  boxSizing: "border-box",
  transition: "all 0.2s ease",
  "&:focus": {
    borderColor: "#667eea",
    boxShadow: "0 0 0 3px rgba(65, 105, 225, 0.12)",
  },
  "&::placeholder": { color: "#94a3b8" },
};

const FormField = ({ label, value, placeholder, required, full, as = "input" }) => (
  <Box sx={{ gridColumn: { xs: "span 1", md: full ? "span 2" : "span 1" } }}>
    <FormLabel required={required}>{label}</FormLabel>
    <Box
      component={as}
      defaultValue={value}
      placeholder={placeholder}
      sx={{
        ...fieldSx,
        ...(as === "textarea"
          ? {
              height: "auto",
              minHeight: 110,
              py: "12px",
              resize: "vertical",
              lineHeight: 1.5,
            }
          : {}),
      }}
    />
  </Box>
);

const FormSelect = ({ label, value, options }) => (
  <Box>
    <FormLabel>{label}</FormLabel>
    <Box component="select" defaultValue={value} sx={fieldSx}>
      {options.map((option) => (
        <Box component="option" key={option} value={option}>
          {option}
        </Box>
      ))}
    </Box>
  </Box>
);

const FormSection = ({ title, children }) => (
  <Box sx={{ mb: "26px" }}>
    <Typography sx={{ fontSize: "15px", fontWeight: 800, color: "#334155", mb: "16px" }}>{title}</Typography>
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }, gap: "18px" }}>
      {children}
    </Box>
  </Box>
);

export const AipimIncorpNovoEmpreendimento = () => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "none",
      minHeight: "100%",
      p: { xs: "20px", md: "32px 36px 40px" },
      bgcolor: "#f6f7fb",
      fontFamily: "Futura, Arial, sans-serif",
    }}
  >
    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#64748b", mb: "14px" }}>
      <Box component={RouterLink} to="/aipim-incorp/empreendimentos" sx={{ color: "#667eea", textDecoration: "none" }}>
        Empreendimentos
      </Box>{" "}
      &gt; Novo empreendimento
    </Typography>

    <Stack direction={{ xs: "column", md: "row" }} spacing="24px" alignItems={{ xs: "stretch", md: "flex-start" }} justifyContent="space-between" sx={{ mb: "28px" }}>
      <Box>
        <Box component="h1" sx={{ m: 0, mb: "8px", fontSize: "32px", fontWeight: 700, lineHeight: 1.2, color: "#667eea" }}>
          Novo Empreendimento
        </Box>
        <Box component="p" sx={{ m: 0, fontSize: "16px", fontWeight: 400, color: "#64748b", lineHeight: 1.5, maxWidth: 760 }}>
          Cadastre um empreendimento para iniciar a estruturacao do Nucleo de Areas e dos processos do Aipim Incorp.
        </Box>
      </Box>
    </Stack>

    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1fr) 360px" }, gap: "22px", alignItems: "start" }}>
      <Paper elevation={0} sx={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "18px", p: { xs: "22px", md: "28px" }, boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)" }}>
        <Typography sx={{ fontSize: "20px", fontWeight: 800, color: "#1e293b", mb: "6px" }}>Dados do empreendimento</Typography>
        <Typography sx={{ fontSize: "14px", lineHeight: 1.5, color: "#64748b", mb: "24px" }}>
          Informe os dados iniciais para criar a estrutura base do empreendimento no Aipim Incorp.
        </Typography>

        <FormSection title="Identificacao">
          <FormField label="Nome do empreendimento" value="Residencial Alameda Jardins" placeholder="Ex.: Residencial Alameda Jardins" required full />
          <FormSelect label="Tipo de empreendimento" value="Residencial" options={["Residencial", "Comercial", "Uso misto", "Loteamento", "Condominio de casas"]} />
          <FormSelect label="Status inicial" value="Em planejamento" options={["Em planejamento", "Em estruturacao", "Em andamento", "Em revisao"]} />
        </FormSection>

        <FormSection title="Localizacao">
          <FormField label="Cidade" value="Sao Paulo" placeholder="Ex.: Sao Paulo" />
          <FormField label="UF" value="SP" placeholder="Ex.: SP" />
          <FormField label="Endereco" value="Rua Alameda Jardins, 100" placeholder="Ex.: Rua Alameda Jardins, 100" full />
        </FormSection>

        <FormSection title="Responsaveis e datas">
          <FormField label="Responsavel interno" value="Marina Santos" placeholder="Ex.: Coordenador de incorporacao" />
          <FormField label="SPE / Incorporadora" value="Alameda Jardins SPE Ltda." placeholder="Ex.: Alameda Jardins SPE Ltda." />
          <FormField label="Data alvo do RI" value="30/06/2025" placeholder="Ex.: 30/06/2025" />
          <FormField label="Lancamento previsto" value="15/08/2025" placeholder="Ex.: 15/08/2025" />
        </FormSection>

        <Box>
          <Typography sx={{ fontSize: "15px", fontWeight: 800, color: "#334155", mb: "16px" }}>Observacoes iniciais</Typography>
          <FormField
            label="Observacoes"
            as="textarea"
            full
            value="Empreendimento em fase inicial de estruturacao, com projeto legal em revisao e previsao de abertura do processo de Registro de Incorporacao apos validacao do Nucleo de Areas."
            placeholder="Inclua observacoes relevantes sobre o estagio atual do empreendimento, documentos disponiveis ou prioridades iniciais."
          />
        </Box>

        <Stack
          direction={{ xs: "column-reverse", md: "row" }}
          spacing="12px"
          justifyContent="flex-end"
          sx={{ mt: "28px", pt: "22px", borderTop: "1px solid #e2e8f0" }}
        >
          <Button component={RouterLink} to="/aipim-incorp/empreendimentos" sx={{ height: 44, px: "18px", borderRadius: "10px", border: "1px solid #e2e8f0", bgcolor: "#ffffff", color: "#64748b", fontSize: "14px", fontWeight: 700, width: { xs: "100%", md: "auto" } }}>
            Cancelar
          </Button>
          <Button startIcon={<SaveOutlined />} sx={{ height: 44, px: "18px", borderRadius: "10px", border: "1px solid rgba(102, 126, 234, 0.38)", bgcolor: "#ffffff", color: "#667eea", fontSize: "14px", fontWeight: 700, width: { xs: "100%", md: "auto" }, "&:hover": { bgcolor: "#eef2ff" } }}>
            Salvar rascunho
          </Button>
          <Button component={RouterLink} to="/aipim-incorp/empreendimentos/residencial-alameda-jardins" endIcon={<ArrowForwardRounded />} sx={{ height: 44, px: "20px", borderRadius: 3, border: "none", background: portalPrimaryGradient, color: "#ffffff", fontSize: "14px", fontWeight: 800, boxShadow: portalPrimaryShadow, width: { xs: "100%", md: "auto" }, "&:hover": { background: "linear-gradient(135deg, #5d70e6 0%, #6e4299 100%)", transform: "translateY(-1px)", boxShadow: portalPrimaryShadowHover } }}>
            Criar empreendimento
          </Button>
        </Stack>
      </Paper>

      <Paper elevation={0} sx={{ background: "linear-gradient(135deg, #f8fbff 0%, #ffffff 55%, #f7f4ff 100%)", border: "1px solid rgba(102, 126, 234, 0.24)", borderRadius: "18px", p: "24px", boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)", position: { xs: "static", lg: "sticky" }, top: "24px" }}>
        <Box sx={{ width: 56, height: 56, borderRadius: "16px", bgcolor: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center", mb: "18px" }}>
          <AccountTreeOutlined sx={{ color: "#667eea", fontSize: 30 }} />
        </Box>
        <Typography sx={{ fontSize: "18px", fontWeight: 800, lineHeight: 1.35, color: "#1e293b", mb: "10px" }}>
          O empreendimento e a base do Aipim Incorp
        </Typography>
        <Typography sx={{ fontSize: "14px", lineHeight: 1.6, color: "#64748b", mb: "20px" }}>
          Apos criar o empreendimento, voce podera estruturar o Nucleo de Areas, revisar a hierarquia tecnica e ativar os processos contratados.
        </Typography>
        <Stack spacing="14px">
          {[
            ["Cadastrar empreendimento", "Crie a estrutura inicial com nome, tipo, localizacao e responsaveis."],
            ["Acessar Nucleo de Areas", "Entre no empreendimento para iniciar a hierarquia tecnica."],
            ["Enviar arquivos", "Use projeto, quadro de areas, estudo de massa ou documento tecnico."],
            ["Executar processos", "Os modulos contratados passam a consumir a base validada."],
          ].map(([title, text], index) => (
            <Box key={title} sx={{ display: "grid", gridTemplateColumns: "32px 1fr", gap: "12px", alignItems: "flex-start" }}>
              <Box sx={{ width: 32, height: 32, borderRadius: "999px", bgcolor: "#eef2ff", color: "#667eea", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: 800 }}>
                {index + 1}
              </Box>
              <Box>
                <Typography sx={{ fontSize: "14px", fontWeight: 800, color: "#334155", mb: "3px" }}>{title}</Typography>
                <Typography sx={{ fontSize: "13px", lineHeight: 1.45, color: "#64748b" }}>{text}</Typography>
              </Box>
            </Box>
          ))}
        </Stack>
      </Paper>
    </Box>

    <Paper elevation={0} sx={{ mt: "22px", background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "18px", p: { xs: "22px", md: "24px 28px" }, boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)", display: "flex", alignItems: { xs: "flex-start", md: "center" }, justifyContent: "space-between", gap: "24px", flexDirection: { xs: "column", md: "row" } }}>
      <Box>
        <Typography sx={{ fontSize: "18px", fontWeight: 800, color: "#1e293b", mb: "6px" }}>Depois de criar o empreendimento</Typography>
        <Typography sx={{ fontSize: "14px", lineHeight: 1.5, color: "#64748b", maxWidth: 780 }}>
          O proximo passo sera acessar o Nucleo de Areas para enviar os arquivos do projeto, revisar a extracao e publicar uma versao validada da hierarquia.
        </Typography>
      </Box>
      <Stack direction="row" spacing="8px" useFlexGap flexWrap="wrap">
        {["Nucleo de Areas", "Registro de Incorporacao", "Orcamento & Viabilidade"].map((label) => (
          <Chip key={label} label={label} sx={{ height: 32, borderRadius: "999px", bgcolor: "#eef2ff", color: "#667eea", fontSize: "12px", fontWeight: 700 }} />
        ))}
      </Stack>
    </Paper>
  </Box>
);

const processosConsolidados = [
  {
    nome: "Registro de Incorporacao",
    empreendimento: "Residencial Alameda Jardins",
    status: "Em execucao",
    progresso: 68,
    pendencias: "8",
    detalhePendencias: "3 criticas",
    acao: "Acessar processo",
    icon: FactCheckOutlined,
    iconColor: "#667eea",
    iconBackground: "#eef2ff",
    statusBackground: "#dcfce7",
    statusColor: "#15803d",
    progressColor: "#667eea",
  },
  {
    nome: "Orcamento & Viabilidade",
    empreendimento: "Villa Atlantica",
    status: "Aguardando hierarquia publicada",
    progresso: 15,
    pendencias: "3",
    detalhePendencias: "1 critica",
    acao: "Acessar processo",
    icon: CalculateOutlined,
    iconColor: "#ea580c",
    iconBackground: "#fff3e8",
    statusBackground: "#ffedd5",
    statusColor: "#c2410c",
    progressColor: "#ea580c",
  },
  {
    nome: "Registro de Incorporacao",
    empreendimento: "Torre Empresarial Jardins",
    status: "Em planejamento",
    progresso: 22,
    pendencias: "5",
    detalhePendencias: "2 aguardando responsavel",
    acao: "Acessar processo",
    icon: FactCheckOutlined,
    iconColor: "#667eea",
    iconBackground: "#eef2ff",
    statusBackground: "#eef2ff",
    statusColor: "#667eea",
    progressColor: "#667eea",
  },
  {
    nome: "Memorial & Manual",
    empreendimento: "Torre Empresarial Jardins",
    status: "Modulo nao contratado",
    progresso: 0,
    pendencias: "-",
    detalhePendencias: "Disponivel para ativacao",
    acao: "Conhecer modulo",
    icon: ArticleOutlined,
    iconColor: "#7c3aed",
    iconBackground: "#f3e8ff",
    statusBackground: "#fee2e2",
    statusColor: "#dc2626",
    progressColor: "#7c3aed",
  },
  {
    nome: "NBR 12721",
    empreendimento: "Residencial Alameda Jardins",
    status: "Disponivel para contratacao",
    progresso: 0,
    pendencias: "-",
    detalhePendencias: "Depende do Nucleo de Areas",
    acao: "Solicitar ativacao",
    icon: DescriptionOutlined,
    iconColor: "#7c3aed",
    iconBackground: "#f3e8ff",
    statusBackground: "#f3e8ff",
    statusColor: "#7c3aed",
    progressColor: "#7c3aed",
  },
];

const ProcessFilterPill = ({ label, count, active, badgeBg, badgeColor }) => (
  <Box
    sx={{
      height: 42,
      px: "16px",
      borderRadius: "999px",
      border: active ? "1px solid rgba(102, 126, 234, 0.38)" : "1px solid #e2e8f0",
      bgcolor: active ? "#eef2ff" : "#ffffff",
      color: active ? "#667eea" : "#64748b",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      fontFamily: "Futura, Arial, sans-serif",
      fontSize: "14px",
      fontWeight: 700,
      whiteSpace: "nowrap",
      flexShrink: 0,
    }}
  >
    {label}
    <Box
      component="span"
      sx={{
        minWidth: 22,
        height: 22,
        borderRadius: "999px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: badgeBg,
        color: badgeColor,
        fontSize: "12px",
        fontWeight: 800,
      }}
    >
      {count}
    </Box>
  </Box>
);

const ConsolidatedProcessCard = ({ processo }) => {
  const Icon = processo.icon;

  return (
    <Box
      sx={{
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "16px",
        p: "18px",
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "64px minmax(0, 1fr)",
          xl: "64px minmax(280px, 1.4fr) 190px 170px 180px 180px",
        },
        gridTemplateAreas: {
          xs: `"icon" "info" "status" "progress" "pending" "action"`,
          md: `"icon info" "icon status" "icon progress" "icon pending" "icon action"`,
          xl: `"icon info status progress pending action"`,
        },
        gap: { xs: "14px", xl: "18px" },
        alignItems: "center",
        minHeight: 118,
        transition: "all 0.2s ease",
        "&:hover": {
          background: "#f8fbff",
          borderColor: "rgba(102, 126, 234, 0.38)",
          boxShadow: "0 8px 18px rgba(15, 23, 42, 0.05)",
          transform: "translateY(-1px)",
        },
      }}
    >
      <Box sx={{ gridArea: "icon", width: 56, height: 56, borderRadius: "16px", bgcolor: processo.iconBackground, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon sx={{ color: processo.iconColor, fontSize: 28 }} />
      </Box>
      <Box sx={{ gridArea: "info", minWidth: 0 }}>
        <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "17px", fontWeight: 800, color: "#1e293b", lineHeight: 1.3, mb: "6px" }}>
          {processo.nome}
        </Typography>
        <Stack direction="row" spacing="8px" alignItems="center">
          <ApartmentOutlined sx={{ color: "#64748b", fontSize: 16 }} />
          <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", color: "#64748b" }}>{processo.empreendimento}</Typography>
        </Stack>
      </Box>
      <Box sx={{ gridArea: "status" }}>
        <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#64748b", mb: "8px" }}>Status</Typography>
        <DashboardBadge label={processo.status} bg={processo.statusBackground} color={processo.statusColor} />
      </Box>
      <Box sx={{ gridArea: "progress", minWidth: 0 }}>
        <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#64748b", mb: "8px" }}>Progresso</Typography>
        <Typography sx={{ fontSize: "14px", fontWeight: 800, color: "#1e293b", mb: "8px" }}>{processo.progresso}%</Typography>
        <Box sx={{ width: "100%", height: 6, borderRadius: "999px", bgcolor: "#e2e8f0", overflow: "hidden" }}>
          <Box sx={{ width: `${processo.progresso}%`, height: "100%", borderRadius: "999px", bgcolor: processo.progressColor }} />
        </Box>
      </Box>
      <Box sx={{ gridArea: "pending" }}>
        <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#64748b", mb: "8px" }}>Pendencias</Typography>
        <Typography sx={{ fontSize: "15px", fontWeight: 800, color: "#1e293b" }}>{processo.pendencias}</Typography>
        <Typography sx={{ fontSize: "13px", color: "#64748b", mt: "4px" }}>{processo.detalhePendencias}</Typography>
      </Box>
      <Box sx={{ gridArea: "action", justifySelf: { xs: "stretch", xl: "end" } }}>
        <Button
          endIcon={<ChevronRightRounded />}
          sx={{
            height: 40,
            px: "14px",
            borderRadius: "10px",
            border: "1px solid #e2e8f0",
            bgcolor: "#ffffff",
            color: "#667eea",
            fontFamily: "Futura, Arial, sans-serif",
            fontSize: "13px",
            fontWeight: 700,
            whiteSpace: "nowrap",
            width: { xs: "100%", xl: "auto" },
            "&:hover": { bgcolor: "#eef2ff", borderColor: "rgba(102, 126, 234, 0.38)" },
          }}
        >
          {processo.acao}
        </Button>
      </Box>
    </Box>
  );
};

export const AipimIncorpVisaoGeral = () => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "none",
      minHeight: "100%",
      p: { xs: "24px 18px 32px", md: "32px 36px 40px" },
      bgcolor: "#f6f7fb",
      fontFamily: "Futura, Arial, sans-serif",
    }}
  >
    <Stack spacing="8px" sx={{ mb: "28px" }}>
      <Box
        component="h1"
        sx={{
          m: 0,
          color: "#667eea",
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "32px",
          lineHeight: 1.2,
          fontWeight: 700,
          letterSpacing: 0,
        }}
      >
        Aipim Incorp
      </Box>
      <Box
        component="p"
        sx={{
          m: 0,
          color: "#53627f",
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "16px",
          lineHeight: 1.5,
          fontWeight: 400,
          letterSpacing: 0,
        }}
      >
        Processos inteligentes para a incorporacao imobiliaria dentro do Portal da Aipim.tech.
      </Box>
    </Stack>

    <Paper
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: "1px solid rgba(102, 126, 234, 0.24)",
        background: "linear-gradient(135deg, #f8fbff 0%, #ffffff 55%, #f7f4ff 100%)",
        p: { xs: "24px", md: "28px 32px" },
        mb: "24px",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "160px 1fr 320px" },
          gap: { xs: "24px", lg: "32px" },
          alignItems: "center",
        }}
      >
        <AreaStackIllustration />
        <Box sx={{ minWidth: 0 }}>
          <Box
            component="h2"
            sx={{
              m: 0,
              mb: "10px",
              color: "#1e293b",
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "18px",
              lineHeight: 1.35,
              fontWeight: 700,
              letterSpacing: 0,
            }}
          >
            A Hierarquia de Areas e o nucleo do Aipim Incorp.
          </Box>
          <Box
            component="p"
            sx={{
              m: 0,
              color: "#475569",
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "16px",
              lineHeight: 1.65,
              fontWeight: 400,
              letterSpacing: 0,
              maxWidth: 720,
            }}
          >
            A partir dela, processos como Registro de Incorporacao, Orcamento & Viabilidade, Memorial & Manual,
            NBR 12721 e Programacao de Compras podem ser alimentados por uma mesma base validada do empreendimento.
          </Box>
        </Box>
        <Stack
          spacing="14px"
          sx={{
            borderLeft: { xs: "none", lg: "1px solid #dbe3f0" },
            borderTop: { xs: "1px solid #dbe3f0", lg: "none" },
            pl: { xs: 0, lg: "28px" },
            pt: { xs: "20px", lg: 0 },
          }}
        >
          {["Base unica e validada", "Consistencia e rastreabilidade", "Mais agilidade e menos retrabalho", "Integracao entre modulos"].map(
            (benefit) => (
              <Stack key={benefit} direction="row" spacing="10px" alignItems="center">
                <OverviewCheck />
                <Box
                  component="span"
                  sx={{
                    color: "#242b45",
                    fontFamily: "Futura, Arial, sans-serif",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: 1.35,
                    letterSpacing: 0,
                  }}
                >
                  {benefit}
                </Box>
              </Stack>
            )
          )}
        </Stack>
      </Box>
    </Paper>

    <Paper
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: "1px solid #e2e8f0",
        p: { xs: "22px", md: "24px 24px 22px" },
        mb: 0,
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)",
        bgcolor: "#fff",
      }}
    >
      <Typography
        sx={{
          mb: "20px",
          color: "#1e293b",
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "20px",
          lineHeight: 1.25,
          fontWeight: 700,
        }}
      >
        Como funciona
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" },
          gap: { xs: "18px", lg: "66px" },
          position: "relative",
        }}
      >
        {[
          ["Cadastre o empreendimento", "Informe os dados principais e estruture o seu empreendimento no sistema.", ApartmentOutlined, "blue"],
          ["Envie arquivos do projeto", "Faca o upload das plantas, memoriais e documentos tecnicos do empreendimento.", CloudUploadOutlined, "green"],
          ["Revise o Nucleo de Areas", "O sistema processa os dados e voce valida a Hierarquia de Areas gerada automaticamente.", ViewInArOutlined, "purple"],
          ["Execute os processos contratados", "Com o nucleo validado, execute os modulos e processos contratados com mais precisao e agilidade.", RocketLaunchOutlined, "orange"],
        ].map(([title, text, Icon, tone], index) => (
          <Box key={title} sx={{ position: "relative", minWidth: 0 }}>
            {index < 3 && (
              <Box
                aria-hidden
                sx={{
                  display: { xs: "none", lg: "block" },
                  position: "absolute",
                  top: "58px",
                  left: "calc(100% + 8px)",
                  width: "50px",
                  height: "32px",
                  zIndex: 2,
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "15px",
                    left: 0,
                    right: 0,
                    borderTop: "2px dashed #c7d6ff",
                  },
                  "&::after": {
                    content: '"›"',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 30,
                    height: 30,
                    borderRadius: "999px",
                    border: "1px solid #c7d6ff",
                    bgcolor: "#fff",
                    color: "#667eea",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    lineHeight: 1,
                    fontWeight: 700,
                    boxShadow: "0 2px 6px rgba(65,105,225,0.08)",
                  },
                }}
              />
            )}
            <OverviewStepCard number={index + 1} title={title} text={text} icon={Icon} tone={tone} />
          </Box>
        ))}
      </Box>
    </Paper>

    <Paper
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: "1px solid #e2e8f0",
        p: "24px",
        mt: "18px",
        bgcolor: "#fff",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)",
      }}
    >
      <Typography
        sx={{
          mb: "18px",
          color: "#1e293b",
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "20px",
          lineHeight: 1.25,
          fontWeight: 700,
        }}
      >
        Modulos e processos
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
            lg: "repeat(5, minmax(0, 1fr))",
          },
          gap: "16px",
        }}
      >
        {[
          { ...moduleCards[0], tone: "blue" },
          { ...moduleCards[1], tone: "green" },
          { ...moduleCards[2], tone: "orange" },
          { ...moduleCards[3], tone: "purple" },
          { ...moduleCards[4], tone: "purple" },
        ].map((module) => (
          <Box key={module.title} sx={{ minWidth: 0 }}>
            <OverviewModuleCard {...module} />
          </Box>
        ))}
      </Box>
    </Paper>
  </Box>
);

export const AipimIncorpInicio = () => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "none",
      minHeight: "100%",
      p: { xs: "24px 18px 32px", md: "32px 36px 40px" },
      bgcolor: "#f6f7fb",
      fontFamily: "Futura, Arial, sans-serif",
    }}
  >
    <Stack spacing="8px" sx={{ mb: "28px" }}>
      <Box
        component="h1"
        sx={{
          m: 0,
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "32px",
          fontWeight: 700,
          lineHeight: 1.2,
          color: "#667eea",
          letterSpacing: 0,
        }}
      >
        Aipim Incorp - Inicio
      </Box>
      <Box
        component="p"
        sx={{
          m: 0,
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: 1.5,
          color: "#64748b",
          letterSpacing: 0,
        }}
      >
        Centralize e acompanhe os processos inteligentes que estruturam cada etapa do seu desenvolvimento imobiliario.
      </Box>
    </Stack>

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" },
        gap: "18px",
        mb: "24px",
      }}
    >
      <DashboardKpiCard
        label="Empreendimentos ativos"
        value="3"
        icon={ApartmentOutlined}
        iconColor="#667eea"
        iconBackground="#eef2ff"
        valueColor="#667eea"
      />
      <DashboardKpiCard
        label="Processos em execucao"
        value="5"
        icon={SettingsOutlined}
        iconColor="#16a34a"
        iconBackground="#ecfdf3"
        valueColor="#15803d"
      />
      <DashboardKpiCard
        label="Pendencias criticas"
        value="12"
        icon={WarningAmberRounded}
        iconColor="#ea580c"
        iconBackground="#fff3e8"
        valueColor="#c2410c"
      />
      <DashboardKpiCard
        label="Hierarquias em revisao"
        value="2"
        icon={AccountTreeOutlined}
        iconColor="#7c3aed"
        iconBackground="#f3e8ff"
        valueColor="#6d28d9"
      />
    </Box>

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1.1fr) minmax(0, 1fr)" },
        gap: "18px",
        alignItems: "start",
      }}
    >
      <DashboardSectionCard title="Empreendimentos recentes">
        <EmpreendimentoRecentCard
          name="Residencial Alameda Jardins"
          meta="Residencial - Sao Paulo/SP"
          status="Em andamento"
          badgeBg="#dcfce7"
          badgeColor="#15803d"
          iconColor="#667eea"
          iconBackground="linear-gradient(135deg, #dbeafe, #e0e7ff)"
        />
        <EmpreendimentoRecentCard
          name="Villa Atlantica"
          meta="Residencial - Balneario Camboriu/SC"
          status="Em planejamento"
          badgeBg="#eef2ff"
          badgeColor="#667eea"
          iconColor="#667eea"
          iconBackground="linear-gradient(135deg, #e0f2fe, #eef2ff)"
        />
        <EmpreendimentoRecentCard
          name="Torre Empresarial Jardins"
          meta="Comercial - Sao Paulo/SP"
          status="Em estruturacao"
          badgeBg="#fef3c7"
          badgeColor="#b45309"
          iconColor="#b45309"
          iconBackground="linear-gradient(135deg, #fef3c7, #fff7ed)"
        />
        <Box sx={{ display: "flex", justifyContent: "center", mt: "18px" }}>
          <Button
            component={RouterLink}
            to="/aipim-incorp/empreendimentos"
            endIcon={<ChevronRightRounded />}
            sx={{
              color: "#667eea",
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "14px",
              fontWeight: 600,
              "&:hover": { bgcolor: "rgba(65,105,225,0.06)" },
            }}
          >
            Ver todos os empreendimentos
          </Button>
        </Box>
      </DashboardSectionCard>

      <DashboardSectionCard title="Processos em atencao">
        <ProcessoAtencaoCard
          title="RI Alameda Jardins"
          description="68% concluido"
          status="Em andamento"
          icon={FactCheckOutlined}
          iconColor="#667eea"
          iconBackground="#eef2ff"
          badgeBg="#eef2ff"
          badgeColor="#667eea"
          progress={68}
        />
        <ProcessoAtencaoCard
          title="Orcamento Villa Atlantica"
          description="Aguardando hierarquia publicada"
          status="Aguardando"
          icon={CalculateOutlined}
          iconColor="#ea580c"
          iconBackground="#fff3e8"
          badgeBg="#ffedd5"
          badgeColor="#c2410c"
        />
        <ProcessoAtencaoCard
          title="Memorial Torre Empresarial"
          description="Modulo nao contratado"
          status="Acao necessaria"
          icon={ArticleOutlined}
          iconColor="#7c3aed"
          iconBackground="#f3e8ff"
          badgeBg="#fee2e2"
          badgeColor="#dc2626"
        />
      </DashboardSectionCard>
    </Box>
  </Box>
);

export const AipimIncorpEmpreendimentos = () => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "none",
      minHeight: "100%",
      p: { xs: "24px 18px 32px", md: "32px 36px 40px" },
      bgcolor: "#f6f7fb",
      fontFamily: "Futura, Arial, sans-serif",
    }}
  >
    <Paper
      elevation={0}
      sx={{
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "18px",
        p: { xs: "22px", md: "28px" },
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "stretch", md: "flex-start" }}
        justifyContent="space-between"
        spacing="24px"
        sx={{ mb: "28px" }}
      >
        <Box>
          <Box
            component="h1"
            sx={{
              m: 0,
              mb: "8px",
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "32px",
              fontWeight: 700,
              lineHeight: 1.2,
              color: "#667eea",
            }}
          >
            Empreendimentos
          </Box>
          <Box
            component="p"
            sx={{
              m: 0,
              fontFamily: "Futura, Arial, sans-serif",
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: 1.5,
              color: "#64748b",
              maxWidth: 760,
            }}
          >
            Cadastre e acompanhe os empreendimentos que servirao de base para os processos do Aipim Incorp.
          </Box>
        </Box>
        <Button
          component={RouterLink}
          to="/aipim-incorp/empreendimentos/novo"
          startIcon={<AddRounded sx={{ fontSize: 19 }} />}
          sx={{
            height: 44,
            px: "18px",
            borderRadius: 3,
            background: portalPrimaryGradient,
            color: "#ffffff",
            fontFamily: "Futura, Arial, sans-serif",
            fontSize: "14px",
            fontWeight: 700,
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            border: "none",
            boxShadow: portalPrimaryShadow,
            transition: "all 0.2s ease",
            width: { xs: "100%", md: "auto" },
            "&:hover": {
              background: "linear-gradient(135deg, #5d70e6 0%, #6e4299 100%)",
              transform: "translateY(-1px)",
              boxShadow: portalPrimaryShadowHover,
            },
          }}
        >
          Novo empreendimento
        </Button>
      </Stack>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          mb: "22px",
          flexWrap: "wrap",
          overflowX: { xs: "auto", md: "visible" },
          pb: { xs: "4px", md: 0 },
        }}
      >
        <EmpreendimentoFilterPill label="Todos" count="4" active badgeBg="#eef2ff" badgeColor="#667eea" />
        <EmpreendimentoFilterPill label="Em andamento" count="2" badgeBg="#dcfce7" badgeColor="#15803d" />
        <EmpreendimentoFilterPill label="Em revisao" count="1" badgeBg="#ffedd5" badgeColor="#c2410c" />
        <EmpreendimentoFilterPill label="Concluidos" count="1" badgeBg="#f3e8ff" badgeColor="#7c3aed" />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0,
          border: "1px solid #e2e8f0",
          borderRadius: "16px",
          overflow: "hidden",
          background: "#ffffff",
        }}
      >
        {empreendimentos.map((item, index) => (
          <EmpreendimentoListRow key={item.id} item={item} isLast={index === empreendimentos.length - 1} />
        ))}
      </Box>

      <Typography
        sx={{
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "14px",
          color: "#94a3b8",
          fontWeight: 500,
          textAlign: "center",
          pt: "20px",
        }}
      >
        Exibindo 4 de 4 empreendimentos
      </Typography>
    </Paper>
  </Box>
);

const DetailCard = ({ children, sx }) => (
  <Paper
    elevation={0}
    sx={{
      background: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: "16px",
      p: "24px",
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)",
      ...sx,
    }}
  >
    {children}
  </Paper>
);

const DetailSectionHeader = ({ title, subtitle, action }) => (
  <Stack direction={{ xs: "column", md: "row" }} spacing={2} justifyContent="space-between" sx={{ mb: "24px" }}>
    <Box>
      <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "26px", fontWeight: 800, color: "#667eea", mb: "8px" }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "15px", color: "#64748b", lineHeight: 1.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {action}
  </Stack>
);

const SeverityBadge = ({ label }) => {
  const palette = {
    Alto: { bg: "#fee2e2", color: "#dc2626" },
    Medio: { bg: "#ffedd5", color: "#c2410c" },
    Baixo: { bg: "#dcfce7", color: "#15803d" },
  };
  const tone = palette[label] || { bg: "#eef2ff", color: "#667eea" };
  return <DashboardBadge label={label} bg={tone.bg} color={tone.color} />;
};

const DetailTabs = ({ current }) => {
  const tabs = [
    ["resumo", "Resumo", SpaceDashboardOutlined],
    ["nucleo-de-areas", "Areas", AccountTreeOutlined],
    ["processos", "Processos", TimelineOutlined],
    ["documentos", "Documentos", DescriptionOutlined],
    ["agentes", "Agentes", SmartToyOutlined],
    ["historico", "Historico", HistoryOutlined],
  ];

  return (
    <Box
      sx={{
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "16px",
        p: "6px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        mb: "18px",
        boxShadow: "0 4px 14px rgba(15, 23, 42, 0.025)",
        overflowX: "auto",
      }}
    >
      {tabs.map(([value, label, Icon]) => (
        <Box
          key={value}
          component={RouterLink}
          to={`/aipim-incorp/empreendimentos/residencial-alameda-jardins/${value}`}
          sx={{
            height: 42,
            px: "16px",
            borderRadius: "10px",
            fontFamily: "Futura, Arial, sans-serif",
            fontSize: "14px",
            fontWeight: 700,
            color: current === value ? "#667eea" : "#64748b",
            bgcolor: current === value ? "#eef2ff" : "transparent",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            textDecoration: "none",
            whiteSpace: "nowrap",
            "&:hover": { bgcolor: current === value ? "#eef2ff" : "#f8fafc" },
          }}
        >
          <Icon sx={{ fontSize: 18 }} />
          {label}
        </Box>
      ))}
    </Box>
  );
};

const DetailShell = ({ tab, children }) => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "none",
      minHeight: "100%",
      p: { xs: "24px 18px 32px", md: "32px 36px 40px" },
      bgcolor: "#f6f7fb",
      fontFamily: "Futura, Arial, sans-serif",
    }}
  >
    <DetailCard sx={{ borderRadius: "18px", p: { xs: "22px", md: "24px 28px" }, mb: "18px" }}>
      <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "13px", fontWeight: 600, color: "#64748b", mb: "16px" }}>
        <Box component="span" sx={{ color: "#667eea" }}>Empreendimentos</Box> &gt; Residencial Alameda Jardins
      </Typography>
      <Stack direction={{ xs: "column", lg: "row" }} spacing="24px" alignItems={{ xs: "stretch", lg: "center" }} justifyContent="space-between">
        <Stack direction="row" spacing="16px" alignItems="center">
          <Box sx={{ width: 76, height: 76, borderRadius: "16px", background: "linear-gradient(135deg, #dbeafe, #e0e7ff)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <ApartmentOutlined sx={{ color: "#667eea", fontSize: 34 }} />
          </Box>
          <Box>
            <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: { xs: "23px", md: "28px" }, fontWeight: 800, lineHeight: 1.2, color: "#1e293b", mb: "8px" }}>
              Empreendimento - Residencial Alameda Jardins
            </Typography>
            <Stack direction="row" spacing="10px" useFlexGap flexWrap="wrap" alignItems="center">
              <Typography sx={{ fontSize: "15px", color: "#64748b" }}>Residencial • Sao Paulo/SP</Typography>
              <DashboardBadge label="Em andamento" bg="#dcfce7" color="#15803d" />
            </Stack>
          </Box>
        </Stack>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, auto)" }, gap: "12px" }}>
          {[
            ["Data alvo RI", "30/06/2025"],
            ["Lancamento previsto", "Agosto/2025"],
            ["Status do Nucleo", "v1.2 publicada"],
          ].map(([label, value]) => (
            <Box key={label} sx={{ border: "1px solid #e2e8f0", borderRadius: "14px", p: "12px 14px", minWidth: 150, bgcolor: "#f8fbff" }}>
              <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#64748b", mb: "5px" }}>{label}</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 800, color: "#1e293b" }}>{value}</Typography>
            </Box>
          ))}
        </Box>
      </Stack>
    </DetailCard>
    <DetailTabs current={tab} />
    {children}
  </Box>
);

const SummaryTab = () => (
  <Box>
    <DetailSectionHeader
      title="Resumo"
      subtitle="Visao geral do empreendimento, processos contratados, pendencias e status do Nucleo de Areas."
    />
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }, gap: "18px", mb: "24px" }}>
      {[
        ["Nucleo de Areas", "v1.2 publicada", "Base validada do empreendimento", AccountTreeOutlined, "#667eea", "#eef2ff"],
        ["Processos contratados", "2", "RI e Orcamento & Viabilidade", TimelineOutlined, "#16a34a", "#ecfdf3"],
        ["Pendencias abertas", "8", "3 com alta prioridade", WarningAmberRounded, "#ea580c", "#fff3e8"],
        ["Documentos vinculados", "14", "Arquivos usados nos processos", DescriptionOutlined, "#7c3aed", "#f3e8ff"],
      ].map(([label, value, desc, Icon, color, bg]) => (
        <DetailCard key={label} sx={{ p: "20px" }}>
          <Stack direction="row" spacing="14px">
            <Box sx={{ width: 48, height: 48, borderRadius: "14px", bgcolor: bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon sx={{ color, fontSize: 26 }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#64748b", mb: "6px" }}>{label}</Typography>
              <Typography sx={{ fontSize: "22px", fontWeight: 800, color: "#1e293b", lineHeight: 1.1, mb: "6px" }}>{value}</Typography>
              <Typography sx={{ fontSize: "13px", color: "#64748b", lineHeight: 1.4 }}>{desc}</Typography>
            </Box>
          </Stack>
        </DetailCard>
      ))}
    </Box>

    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1.1fr) minmax(0, 1fr)" }, gap: "18px", mb: "18px" }}>
      <DetailCard>
        <SectionTitle title="Nucleo de Areas" />
        <Typography sx={{ color: "#64748b", lineHeight: 1.6, mb: "18px" }}>
          A Hierarquia de Areas deste empreendimento esta publicada na versao v1.2 e pode ser consumida pelos processos contratados.
        </Typography>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" }, gap: "12px", mb: "18px" }}>
          {[
            ["Versao ativa", "v1.2"],
            ["Origem", "PDF Projeto Legal v03"],
            ["Status", "Publicada"],
            ["Ultima publicacao", "24/05/2025 as 14:32"],
          ].map(([label, value]) => (
            <Box key={label} sx={{ bgcolor: "#f8fbff", border: "1px solid #e2e8f0", borderRadius: "12px", p: "12px" }}>
              <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#64748b", mb: "5px" }}>{label}</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 800, color: "#1e293b" }}>{value}</Typography>
            </Box>
          ))}
        </Box>
        <Button component={RouterLink} to="/aipim-incorp/empreendimentos/residencial-alameda-jardins/nucleo-de-areas" endIcon={<ChevronRightRounded />} sx={{ color: "#667eea", fontWeight: 700 }}>
          Ver Nucleo de Areas
        </Button>
      </DetailCard>
      <DetailCard>
        <SectionTitle title="Pendencias principais" />
        <Stack spacing="12px">
          {[
            ["Revisar impacto da area da Sala de Estar Tipo 1", "Alto"],
            ["Validar documentos para Registro de Incorporacao", "Medio"],
            ["Confirmar premissas de custo/m2 para orcamento", "Baixo"],
          ].map(([text, severity]) => (
            <Stack key={text} direction="row" spacing="12px" alignItems="center" justifyContent="space-between" sx={{ border: "1px solid #e2e8f0", borderRadius: "12px", p: "12px" }}>
              <Stack direction="row" spacing="10px" alignItems="center">
                <WarningAmberRounded sx={{ color: severity === "Alto" ? "#dc2626" : "#ea580c", fontSize: 20 }} />
                <Typography sx={{ color: "#1e293b", fontWeight: 700, fontSize: "14px" }}>{text}</Typography>
              </Stack>
              <SeverityBadge label={severity} />
            </Stack>
          ))}
        </Stack>
      </DetailCard>
    </Box>

    <DetailCard>
      <SectionTitle title="Processos contratados" />
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" }, gap: "16px" }}>
        <ProcessCard title="Registro de Incorporacao" description="Elaboracao e organizacao da documentacao para o cartorio de registro." status="Em execucao" progress={68} pending="8 pendencias" action="Acessar processo" />
        <ProcessCard title="Orcamento & Viabilidade" description="Estimativa de custos, viabilidade e analise economico-financeira do empreendimento." status="Aguardando revisao final" progress={15} pending="3 pendencias" action="Acessar processo" />
      </Box>
    </DetailCard>
  </Box>
);

const TreeRow = ({ label, level = 0, selected = false }) => (
  <Box
    sx={{
      ml: level * 2,
      px: "10px",
      py: "8px",
      borderRadius: "10px",
      bgcolor: selected ? "#eef2ff" : "transparent",
      color: selected ? "#667eea" : "#334155",
      fontWeight: selected ? 800 : 650,
      fontSize: "14px",
    }}
  >
    {label}
  </Box>
);

const NucleoAreasTab = () => (
  <Stack spacing="18px">
    <DetailSectionHeader
      title="Nucleo de Areas"
      subtitle="Hierarquia tecnica do empreendimento que alimenta os processos do Aipim Incorp."
      action={
        <Stack direction="row" spacing="10px">
          <Button variant="outlined" startIcon={<UploadFileOutlined />} sx={{ borderRadius: "10px", fontWeight: 700 }}>Enviar arquivo</Button>
          <Button variant="contained" startIcon={<PublishedWithChangesOutlined />} sx={{ borderRadius: 3, background: portalPrimaryGradient, boxShadow: portalPrimaryShadow, fontWeight: 700, "&:hover": { background: "linear-gradient(135deg, #5d70e6 0%, #6e4299 100%)", boxShadow: portalPrimaryShadowHover } }}>Publicar versao</Button>
        </Stack>
      }
    />

    <DetailCard sx={{ p: "16px" }}>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
        <Chip label="Versao ativa: v1.2" />
        <Chip label="Origem: PDF Projeto Legal v03" />
        <StatusChip label="Em revisao" />
      </Stack>
    </DetailCard>

    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", lg: "320px minmax(0, 1fr) 360px" }, gap: "18px", alignItems: "start" }}>
      <Box>
        <DetailCard sx={{ height: "100%", p: "20px" }}>
          <SectionTitle title="Hierarquia do Nucleo" />
          <Stack spacing={0.2}>
            <TreeRow label="Empreendimento" />
            <TreeRow label="Terreno" level={1} />
            <TreeRow label="Edificacao" level={2} />
            <TreeRow label="Pavimento" level={3} />
            <TreeRow label="Tipologia" level={4} />
            <TreeRow label="Unidade Autonoma" level={5} />
            <TreeRow label="Ambiente" level={6} />
            <TreeRow label="Sala de Estar Tipo 1" level={7} selected />
            <TreeRow label="Cozinha Tipo 1" level={7} />
            <TreeRow label="Dormitorio Tipo 1" level={7} />
            <TreeRow label="Superficie" />
          </Stack>
        </DetailCard>
      </Box>
      <Box>
        <DetailCard sx={{ height: "100%", p: "20px" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
            <SectionTitle title="Detalhes do selecionado" subtitle="Sala de Estar Tipo 1 - Ambiente" />
            <Button size="small" startIcon={<EditOutlined />}>
              Editar
            </Button>
          </Stack>
          <StatusChip label="Ativo" />
          <Grid container spacing={1.5} sx={{ mt: 1 }}>
            {[
              ["Area atual", "17,20 m2"],
              ["Area anterior", "16,50 m2"],
              ["Variacao", "+0,70 m2"],
              ["Origem", "PDF pagina 12"],
              ["Ultima atualizacao", "20/05/2025 14:32"],
              ["Responsavel", "Aipim Incorp"],
            ].map(([label, value]) => (
              <Grid item xs={12} sm={6} key={label}>
                <Typography variant="caption" color="text.secondary">
                  {label}
                </Typography>
                <Typography fontWeight={800}>{value}</Typography>
              </Grid>
            ))}
          </Grid>
          <Typography color="text.secondary" sx={{ mt: 2 }}>
            Observacao: Ambiente padrao da tipologia Tipo 1.
          </Typography>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mt: 2 }}>
            {["Ambiente Interno", "Area Privativa", "Computavel", "Uso: Estar", "Piso: Porcelanato", "Pe-direito: 2,70 m"].map(
              (tag) => (
                <Chip key={tag} label={tag} size="small" />
              )
            )}
          </Stack>
        </DetailCard>
      </Box>
      <Box>
        <DetailCard sx={{ height: "100%", p: "20px" }}>
          <SectionTitle title="Impactos nos modulos" />
          <Stack divider={<Divider flexItem />} spacing={1.2}>
            {areaImpacts.map(([module, impact, severity]) => (
              <Stack key={module} spacing={0.6}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                  <Typography fontWeight={800}>{module}</Typography>
                  <SeverityBadge label={severity} />
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  {impact}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </DetailCard>
      </Box>
    </Box>

    <DetailCard>
      <SectionTitle title="Alteracoes detectadas" />
      <Stack divider={<Divider flexItem />} spacing={1.2}>
        {areaChanges.map(([message, severity], index) => (
          <Stack key={message} direction={{ xs: "column", md: "row" }} spacing={1.5} justifyContent="space-between">
            <Box>
              <Typography fontWeight={800}>Alteracao {index + 1}</Typography>
              <Typography color="text.secondary">{message}</Typography>
              <Typography variant="caption" color="text.secondary">
                Ha 2 horas
              </Typography>
            </Box>
            <SeverityBadge label={severity} />
          </Stack>
        ))}
      </Stack>
    </DetailCard>
  </Stack>
);

const ProcessosTab = () => (
  <Stack spacing="18px">
    <DetailSectionHeader title="Processos" subtitle="Modulos operacionais que utilizam a base validada do empreendimento." />
    <Alert severity="success" icon={<CheckCircleOutlineRounded />} sx={{ borderRadius: "16px", border: "1px solid #bbf7d0", bgcolor: "#f0fdf4" }}>
      <Typography fontWeight={850}>Nucleo de Areas publicado em v1.2 - os processos abaixo podem consumir essa base.</Typography>
      <Typography variant="body2">Publicado em 24/05/2025 as 14:32 por Aipim.tech</Typography>
      <Button size="small" sx={{ mt: 0.5 }}>
        Ver detalhes da publicacao
      </Button>
    </Alert>

    <SectionTitle title="Processos contratados" />
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" }, gap: "16px" }}>
      {[
        ["Registro de Incorporacao", "Elaboracao e organizacao da documentacao para o cartorio de registro.", "Em execucao", 68, "8"],
        ["Orcamento & Viabilidade", "Estimativa de custos, viabilidade e analise economico-financeira do empreendimento.", "Aguardando revisao final", 15, null],
      ].map(([title, description, status, progress, pending]) => (
        <Box key={title}>
          <ProcessCard title={title} description={description} status={status} progress={progress} pending={pending} action="Acessar processo" />
        </Box>
      ))}
    </Box>

    <SectionTitle title="Disponiveis para contratacao" />
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: "16px" }}>
      {[
        ["Memorial & Manual", "Geracao do memorial descritivo e manual do proprietario conforme escopo do projeto.", "Informativo", "Conhecer modulo"],
        ["NBR 12721", "Calculo da area privativa, equivalente e estimada conforme NBR 12721.", "Normativo", "Solicitar ativacao"],
        ["Programacao de Compras", "Planejamento e cronograma de compras alinhado ao avanco fisico do empreendimento.", "Operacional", "Solicitar ativacao"],
      ].map(([title, description, category, action]) => (
        <Box key={title}>
          <DetailCard sx={{ height: "100%" }}>
            <Stack spacing={1.3}>
              <Chip label={category} size="small" sx={{ alignSelf: "flex-start", fontWeight: 750 }} />
              <Typography variant="h6" fontWeight={850}>{title}</Typography>
              <Typography color="text.secondary">{description}</Typography>
              <Button sx={{ alignSelf: "flex-start" }}>{action}</Button>
            </Stack>
          </DetailCard>
        </Box>
      ))}
    </Box>

    <Button startIcon={<SupportAgentOutlined />} sx={{ alignSelf: "flex-start" }}>
      Problemas com um processo? Fale com o suporte
    </Button>
  </Stack>
);

const ProcessCard = ({ title, description, status, progress, pending, action }) => (
  <DetailCard sx={{ height: "100%" }}>
    <Stack spacing={1.5}>
      <Stack direction="row" justifyContent="space-between" spacing={1} alignItems="flex-start">
        <Typography variant="h6" fontWeight={850}>
          {title}
        </Typography>
        <StatusChip label={status} />
      </Stack>
      <Typography color="text.secondary">{description}</Typography>
      <Box>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2" fontWeight={700}>
            Progresso
          </Typography>
          <Typography variant="body2" fontWeight={800}>
            {progress}%
          </Typography>
        </Stack>
        <LinearProgress variant="determinate" value={progress} sx={{ mt: 0.8, height: 8, borderRadius: 999 }} />
      </Box>
      {pending && <Typography color="text.secondary">Pendencias: {pending}</Typography>}
      <Button endIcon={<ChevronRightRounded />} sx={{ alignSelf: "flex-start" }}>
        {action}
      </Button>
    </Stack>
  </DetailCard>
);

const DocumentsTab = () => (
  <SimpleListTab
    title="Documentos"
    subtitle="Arquivos e documentos utilizados pelos processos do Aipim Incorp."
    icon={FolderOutlined}
    items={[
      ["PDF Projeto Legal v03", "Projeto", "Utilizado no Nucleo de Areas", "20/05/2025"],
      ["Quadro de Areas Preliminar", "Quadro de areas", "Em revisao", "18/05/2025"],
      ["Memorial Descritivo Preliminar", "Memorial", "Pendente de validacao", "16/05/2025"],
      ["Minuta da Convencao", "Juridico", "Aguardando upload", "-"],
    ]}
  />
);

const AgentsTab = () => (
  <SimpleCardsTab
    title="Agentes"
    subtitle="Agentes de IA que apoiam a leitura, organizacao e acompanhamento dos processos deste empreendimento."
    items={[
      ["Agente de Incorporacao", "Responde duvidas sobre o andamento do empreendimento, status dos processos e pendencias principais.", "Ativo"],
      ["Agente Documental", "Apoia a leitura, classificacao e conferencia inicial de documentos vinculados ao empreendimento.", "Em configuracao"],
      ["Agente de Pendencias", "Monitora tarefas, prazos, alteracoes e riscos operacionais dos processos contratados.", "Em breve"],
    ]}
  />
);

const HistoryTab = () => (
  <SimpleListTab
    title="Historico"
    subtitle="Linha do tempo de eventos, publicacoes, revisoes e alteracoes do empreendimento."
    icon={HistoryOutlined}
    items={[
      ["24/05/2025 as 14:32", "Nucleo de Areas publicado em v1.2", "Aipim.tech", ""],
      ["22/05/2025 as 10:15", "Alteracoes detectadas na Sala de Estar Tipo 1", "Aipim Incorp", ""],
      ["20/05/2025 as 14:32", "PDF Projeto Legal v03 processado", "Aipim Incorp", ""],
      ["18/05/2025 as 09:20", "Empreendimento criado no Aipim Incorp", "rui@aipim.tech", ""],
    ]}
  />
);

const SimpleListTab = ({ title, subtitle, icon: Icon, items }) => (
  <Stack spacing="18px">
    <DetailSectionHeader title={title} subtitle={subtitle} />
    {title === "Documentos" && (
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" }, gap: "16px" }}>
        {[["Total de documentos", "14"], ["Utilizados no Nucleo", "3"], ["Em revisao", "4"], ["Pendentes", "2"]].map(([label, value]) => (
          <DetailCard key={label} sx={{ p: "18px" }}>
            <Typography sx={{ color: "#64748b", fontWeight: 700, fontSize: "13px", mb: "8px" }}>{label}</Typography>
            <Typography sx={{ color: "#1e293b", fontWeight: 800, fontSize: "28px", lineHeight: 1 }}>{value}</Typography>
          </DetailCard>
        ))}
      </Box>
    )}
    <DetailCard>
      <Stack divider={<Divider flexItem />} spacing={1.2}>
        {items.map(([name, type, status, date]) => (
          <Stack key={`${name}-${type}`} direction={{ xs: "column", md: "row" }} justifyContent="space-between" spacing={1.5}>
            <Stack direction="row" spacing={1.5}>
              <Icon color="primary" />
              <Box>
                <Typography fontWeight={850}>{name}</Typography>
                <Typography color="text.secondary" variant="body2">
                  {type}
                </Typography>
              </Box>
            </Stack>
            <Stack alignItems={{ xs: "flex-start", md: "flex-end" }}>
              {status && <Typography fontWeight={750}>{status}</Typography>}
              {date && <Typography color="text.secondary" variant="body2">{date}</Typography>}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </DetailCard>
  </Stack>
);

const SimpleCardsTab = ({ title, subtitle, items }) => (
  <Stack spacing="18px">
    <DetailSectionHeader title={title} subtitle={subtitle} />
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: "16px" }}>
      {items.map(([name, description, status]) => (
        <Box key={name}>
          <DetailCard sx={{ height: "100%" }}>
            <Stack spacing={1.3}>
              <Box sx={{ width: 52, height: 52, borderRadius: "16px", bgcolor: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <AutoAwesomeOutlined sx={{ color: "#667eea" }} />
              </Box>
              <Typography variant="h6" fontWeight={850}>{name}</Typography>
              <Typography color="text.secondary">{description}</Typography>
              <StatusChip label={status} />
              <Button sx={{ alignSelf: "flex-start" }}>{status === "Ativo" ? "Conversar com agente" : status === "Em breve" ? "Conhecer" : "Ver detalhes"}</Button>
            </Stack>
          </DetailCard>
        </Box>
      ))}
    </Box>
  </Stack>
);

export const AipimIncorpEmpreendimentoDetalhe = () => {
  const { tab = "resumo" } = useParams();
  const validTabs = ["resumo", "nucleo-de-areas", "processos", "documentos", "agentes", "historico"];
  const currentTab = validTabs.includes(tab) ? tab : "resumo";
  const tabContent = {
    resumo: <SummaryTab />,
    "nucleo-de-areas": <NucleoAreasTab />,
    processos: <ProcessosTab />,
    documentos: <DocumentsTab />,
    agentes: <AgentsTab />,
    historico: <HistoryTab />,
  };

  return <DetailShell tab={currentTab}>{tabContent[currentTab]}</DetailShell>;
};

export const AipimIncorpProcessos = () => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "none",
      minHeight: "100%",
      p: { xs: "24px 18px 32px", md: "32px 36px 40px" },
      bgcolor: "#f6f7fb",
      fontFamily: "Futura, Arial, sans-serif",
    }}
  >
    <Stack direction={{ xs: "column", md: "row" }} spacing="24px" alignItems={{ xs: "stretch", md: "flex-start" }} justifyContent="space-between" sx={{ mb: "28px" }}>
      <Box>
        <Box component="h1" sx={{ m: 0, mb: "8px", fontFamily: "Futura, Arial, sans-serif", fontSize: "32px", fontWeight: 700, lineHeight: 1.2, color: "#667eea" }}>
          Processos
        </Box>
        <Box component="p" sx={{ m: 0, fontFamily: "Futura, Arial, sans-serif", fontSize: "16px", fontWeight: 400, color: "#64748b", lineHeight: 1.5 }}>
          Acompanhe os modulos operacionais do Aipim Incorp em todos os empreendimentos.
        </Box>
      </Box>
      <Button
        startIcon={<AutoAwesomeOutlined />}
        sx={{
          height: 44,
          px: "18px",
          borderRadius: "10px",
          bgcolor: "#ffffff",
          color: "#667eea",
          fontFamily: "Futura, Arial, sans-serif",
          fontSize: "14px",
          fontWeight: 700,
          border: "1px solid rgba(102, 126, 234, 0.38)",
          width: { xs: "100%", md: "auto" },
          "&:hover": { bgcolor: "#eef2ff" },
        }}
      >
        Conhecer modulos
      </Button>
    </Stack>

    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" }, gap: "18px", mb: "24px" }}>
      <DashboardKpiCard label="Processos em execucao" value="5" icon={SettingsOutlined} iconColor="#667eea" iconBackground="#eef2ff" valueColor="#667eea" />
      <DashboardKpiCard label="Aguardando revisao" value="2" icon={AccessTimeRounded} iconColor="#ea580c" iconBackground="#fff3e8" valueColor="#c2410c" />
      <DashboardKpiCard label="Pendencias criticas" value="12" icon={WarningAmberRounded} iconColor="#dc2626" iconBackground="#fee2e2" valueColor="#dc2626" />
      <DashboardKpiCard label="Modulos disponiveis" value="5" icon={AccountTreeOutlined} iconColor="#7c3aed" iconBackground="#f3e8ff" valueColor="#6d28d9" />
    </Box>

    <Paper elevation={0} sx={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "18px", p: "24px", boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)" }}>
      <Stack direction={{ xs: "column", md: "row" }} spacing="18px" alignItems={{ xs: "stretch", md: "center" }} justifyContent="space-between" sx={{ mb: "20px" }}>
        <Box>
          <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "20px", fontWeight: 800, color: "#1e293b" }}>
            Processos operacionais
          </Typography>
          <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", color: "#64748b", mt: "4px" }}>
            Visao consolidada dos processos por empreendimento.
          </Typography>
        </Box>
        <Button
          startIcon={<DownloadOutlined />}
          sx={{
            height: 40,
            px: "14px",
            borderRadius: "10px",
            border: "1px solid #e2e8f0",
            bgcolor: "#ffffff",
            color: "#667eea",
            fontSize: "13px",
            fontWeight: 700,
            width: { xs: "100%", md: "auto" },
            "&:hover": { bgcolor: "#eef2ff", borderColor: "rgba(102, 126, 234, 0.38)" },
          }}
        >
          Exportar visao
        </Button>
      </Stack>

      <Box sx={{ display: "flex", alignItems: "center", gap: "10px", mb: "22px", flexWrap: "wrap", overflowX: { xs: "auto", md: "visible" }, pb: { xs: "4px", md: 0 } }}>
        <ProcessFilterPill label="Todos" count="5" active badgeBg="#eef2ff" badgeColor="#667eea" />
        <ProcessFilterPill label="Em execucao" count="2" badgeBg="#dcfce7" badgeColor="#15803d" />
        <ProcessFilterPill label="Aguardando" count="1" badgeBg="#ffedd5" badgeColor="#c2410c" />
        <ProcessFilterPill label="Nao contratados" count="1" badgeBg="#fee2e2" badgeColor="#dc2626" />
        <ProcessFilterPill label="Concluidos" count="1" badgeBg="#f3e8ff" badgeColor="#7c3aed" />
      </Box>

      <Stack spacing="14px">
        {processosConsolidados.map((processo) => (
          <ConsolidatedProcessCard key={`${processo.nome}-${processo.empreendimento}`} processo={processo} />
        ))}
      </Stack>
    </Paper>

    <Paper
      elevation={0}
      sx={{
        mt: "22px",
        background: "linear-gradient(135deg, #f8fbff 0%, #ffffff 55%, #f7f4ff 100%)",
        border: "1px solid rgba(102, 126, 234, 0.24)",
        borderRadius: "18px",
        p: "24px",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.035)",
      }}
    >
      <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "20px", fontWeight: 800, color: "#1e293b", mb: "8px" }}>
        Processos disponiveis para contratacao
      </Typography>
      <Typography sx={{ fontFamily: "Futura, Arial, sans-serif", fontSize: "14px", color: "#64748b", mb: "18px" }}>
        Ative novos modulos operacionais sobre a base do Nucleo de Areas dos seus empreendimentos.
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }, gap: "16px" }}>
        {[
          ["Memorial & Manual", "Geracao do memorial descritivo e manual do proprietario conforme escopo do projeto.", "Conhecer modulo", ArticleOutlined],
          ["NBR 12721", "Calculo da area privativa, equivalente e estimada conforme NBR 12721.", "Solicitar ativacao", DescriptionOutlined],
          ["Programacao de Compras", "Planejamento e cronograma de compras alinhado ao avanco fisico do empreendimento.", "Solicitar ativacao", CalendarMonthOutlined],
        ].map(([title, description, cta, Icon]) => (
          <Paper key={title} elevation={0} sx={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "14px", p: "18px", boxShadow: "0 4px 12px rgba(15, 23, 42, 0.025)" }}>
            <Stack spacing="12px">
              <Box sx={{ width: 48, height: 48, borderRadius: "14px", bgcolor: "#f3e8ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Icon sx={{ color: "#7c3aed", fontSize: 26 }} />
              </Box>
              <Typography sx={{ fontWeight: 800, color: "#1e293b", fontSize: "16px" }}>{title}</Typography>
              <Typography sx={{ color: "#64748b", fontSize: "14px", lineHeight: 1.5 }}>{description}</Typography>
              <Button endIcon={<ChevronRightRounded />} sx={{ alignSelf: "flex-start", color: "#667eea", fontWeight: 700 }}>{cta}</Button>
            </Stack>
          </Paper>
        ))}
      </Box>
    </Paper>
  </Box>
);

const AipimIncorpRedirect = () => {
  const location = useLocation();
  return (
    <Box sx={pageSx}>
      <Alert severity="info" icon={<InfoOutlined />}>
        Area Aipim Incorp disponivel. Acesse pelo menu lateral ou abra a pagina de Inicio.
      </Alert>
      <Button component={RouterLink} to="/aipim-incorp/inicio" variant="contained" sx={{ mt: 2 }}>
        Ir para Inicio
      </Button>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
        Origem: {location.pathname}
      </Typography>
    </Box>
  );
};

export default AipimIncorpRedirect;


